(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTextGrid(root) {
    if (!root || root.dataset.tgInit === 'true') return;
    var track = root.querySelector('.text-grid__items');
    var dots = root.querySelectorAll('.text-grid__dot');
    if (!track || !dots.length) return;
    root.dataset.tgInit = 'true';

    var items = track.children;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (items[i]) {
          items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(items, entry.target);
          dots.forEach(function (d, di) {
            var active = di === idx;
            d.classList.toggle('is-active', active);
            d.setAttribute('aria-current', active ? 'true' : 'false');
          });
        });
      }, { root: track, threshold: 0.6 });

      Array.prototype.forEach.call(items, function (item) { io.observe(item); });
    }
  }

  function initAll() {
    document.querySelectorAll('.text-grid--carousel-mobile').forEach(initTextGrid);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // Theme editor re-render support
  document.addEventListener('shopify:section:load', function (e) {
    initTextGrid(e.target.querySelector('.text-grid--carousel-mobile'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
